import { render, staticRenderFns } from "./JcIconBtn.vue?vue&type=template&id=d0fd1a82&scoped=true&"
import script from "./JcIconBtn.vue?vue&type=script&lang=js&"
export * from "./JcIconBtn.vue?vue&type=script&lang=js&"
import style0 from "./JcIconBtn.vue?vue&type=style&index=0&id=d0fd1a82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fd1a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
